import { render, staticRenderFns } from "./staffUserDetail.vue?vue&type=template&id=255567e8"
import script from "./staffUserDetail.vue?vue&type=script&lang=js"
export * from "./staffUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports